import React, { Component } from 'react';
import Firebase from 'firebase';


class Footer extends Component {
  constructor() {
    super();
    this.state = {

    }
  }


  getFecha() {
    var offsetRef = Firebase.database().ref(".info/serverTimeOffset");
    const contex = this;
    var time;
    offsetRef.on("value", function (snap) {
      var offset = snap.val();
      var estimatedServerTimeMs = new Date().getTime() + offset;
      time = estimatedServerTimeMs;
    });
    return time;
  }

  componentDidMount() {
    const contex = this;
    var userRef = Firebase.auth().onAuthStateChanged(function (user) {
        var clientRef = Firebase.database().ref('clients/' + localStorage.client_id);
        clientRef.on("value", snap => {
          contex.setState({ cliente: snap.val() })
        })
    });
  }


  componentWillUpdate(nextProps, nextState) {
    if (nextState.cliente !== this.state.cliente) {
      if(nextState.cliente.trial){
        var date = this.getFecha();
        var dias = new Date(nextState.cliente.expiration - date)
        this.setState({ days: dias.getDate() });
      }
    }
    if(this.state.days !== nextState.days){
      if(nextState.days === 1){
        this.props.history.push("/trial");
      }
    }
  }

  render() {
    return (
      <footer className="app-footer">
        <a href="http://www.operatio.cl">Operatio Spa</a>

        {
          this.state.days ?
            <span className="float-right" style={{ marginRight: "11%" }} ><strong>Versión de prueba</strong>{"   finaliza en " + this.state.days + " días."}</span>
            :
            ""
        }
      </footer>
    )
  }
}

export default Footer;



// WEBPACK FOOTER //
// ./src/components/Footer/Footer.js